import { gql } from '@apollo/client'

export const DENY_CLEARANCE_STATUS = gql`
  mutation DenyClearanceStatus($inputData: DenyClearanceStatusInput!) {
    denyClearanceStatus(inputData: $inputData) {
      id
    }
  }
`
